import { useEffect, useState } from 'react';
export function useSortedGroups(groups, columns, activeColumn, mode) {
  const [sortedGroups, setSortedGroups] = useState(groups);
  useEffect(() => {
    const sortFn = columns.find(c => c.name === activeColumn)?.sortFn;
    const sorted = [...groups.map(group => ({
      ...group,
      data: [...group.data]
    }))];
    if (sortFn) {
      sorted.forEach(group => {
        group.data.sort(sortFn);
      });
      if (mode === 'desc') {
        sorted.forEach(group => {
          group.data.reverse();
        });
      }
    }
    setSortedGroups(sorted);
  }, [activeColumn, columns, groups, mode]);
  return sortedGroups;
}